"use client";
import { ThemeProvider } from "next-themes";

import { AnimatedMultiStepForm } from "../features/Animals/animated-multi-step-form";

export default function AddSilaHome() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="livestock-theme">
      <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 z-10">
        <div className="w-full mx-auto py-8 lg:px-44">
          <div className={"flex flex-col items-center"}>
            {/* <img alt="Logo" className="h-10 lg:h-16 z-20  " src={logo} /> */}
            <h1 className="text-xl font-black text-center mb-8 text-[#015354ff]">
              Livestock Registration System
            </h1>
          </div>
          <style>{`
            .animate-slide-in {
              animation: slideIn 0.3s forwards;
            }
            .animate-slide-out-left {
              animation: slideOutLeft 0.3s forwards;
            }
            .animate-slide-out-right {
              animation: slideOutRight 0.3s forwards;
            }
            
            @keyframes slideIn {
              from {
                opacity: 0;
                transform: translateX(20px);
              }
              to {
                opacity: 1;
                transform: translateX(0);
              }
            }
            
            @keyframes slideOutLeft {
              from {
                opacity: 1;
                transform: translateX(0);
              }
              to {
                opacity: 0;
                transform: translateX(-20px);
              }
            }
            
            @keyframes slideOutRight {
              from {
                opacity: 1;
                transform: translateX(0);
              }
              to {
                opacity: 0;
                transform: translateX(20px);
              }
            }
          `}</style>
          <AnimatedMultiStepForm />
        </div>
      </div>
    </ThemeProvider>
  );
}
